import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import SuccessTick from '../assets/images/success-tick.svg';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from "../lib/Helpers"; // Import utility function
import withForm from '../pages/withForm';
const MoreReset = ({handleChange}) => {
    const {
        settingData,
        setReload
    } = useMenu();
    const [inputText, setInputText] = useState('')
    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const handleAction = async () => {
        if (inputText === 'reset') {
            const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
            if (confirmed) {
                setProcessing(true);     
                setProcessingRing(true);        
                try {
                    const result = await formDataPost('ultimate_security_reset_all_settings', {}); 
                    console.log('result', result);
                    if (result.success) {
                        setProcessingRing(false);
                        setProcessingTick(true)  
                        setReload(Math.random)                      
                        setTimeout(()=> {
                            setProcessingTick(false)
                            setProcessing(false)
                        },1000)
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setProcessing(false);     
                    setProcessingRing(false);
                }
            }   
        }     
    }
    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Lorem, ipsum dolor.", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Lorem ipsum dolor sit amet.", "ultimate-security")}</p>
                        </div>
                        
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={inputText}
                                        onChange={(e) => setInputText( e.target.value)}
                                        placeholder='Type in: "reset"'
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">       
                                    <div className="d-flex align-items-center gap-2">                                    
                                        <button 
                                            type="button" 
                                            className="button button-primary" 
                                            onClick={handleAction}
                                            disabled={processing}
                                        >
                                            {
                                                processing ? __( "Processing...", "ultimate-security" ) : __( "Reset", "ultimate-security" )
                                            }
                                        </button>
                                        {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingTick && <img src={SuccessTick}/>}
                                    </div>
                                    <InfoBox className="small-infobox mt-2" title={__("Note", "ultimate-security")} content={__("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat, officiis.", "ultimate-security")} />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(MoreReset);